module.exports = __webpack_public_path__ + "img/plate-var-02.e4b98f82.png";